import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';

import { showModal } from 'modules/main/store/ducks/modal.actions';

type OwnProps = {
  listingId: string;
  listingType: string;
  render: (arg0: { flagListing: () => void }) => ReactNode;
};
type Props = OwnProps & {
  showModal: typeof showModal;
};
type State = {
  flagged: boolean;
};

class FlagListingContainer extends PureComponent<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    flagged: false,
  };

  showFlagListingModal = () => {
    const { listingId, listingType } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.showModal('FLAG_LISTING', {
      listingId,
      listingType,
      onFlagged: () => {
        this.setState({
          flagged: true,
        });
      },
    });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.flagged) {
      return null;
    }

    return (
      <>
        {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.render({
            flagListing: this.showFlagListingModal,
          })
        }
      </>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default connect(null, {
  showModal,
})(FlagListingContainer);
